export function aliOssImageCompress(url: string) {
  try {
    const urlObj = new URL(url)
    if (!urlObj.searchParams.has('x-oss-process'))
      urlObj.searchParams.set('x-oss-process', 'image/format,webp/quality,Q_20')

    return urlObj.toString()
  }
  catch (error) {
    return url
  }
}
